module.exports = __webpack_public_path__ + "img/male_resultC.9e097824.png";